import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useAuth } from 'src/contexts/auth'
import { AnimalController } from 'src/controllers/animal.controller'
import { UpdateAnimalDto } from 'src/dto/animal.dto'

const animalController = new AnimalController()

export function useRemoveAnimal() {
  const { userFarm: farmId } = useAuth()
  const queryClient = useQueryClient()

  return useMutation({
    mutationKey: ['removeAnimal'],
    mutationFn: (data: UpdateAnimalDto) => animalController.updateAnimal(farmId!, { ...data, acao: 'Removido' }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['getAnimalList'], exact: false })
      queryClient.invalidateQueries({ queryKey: ['animalList'], exact: false })
    }
  })
}
